<div class="main-component body">

    <div class="spacer"></div>
    <div @fade class="inner">

        <div class="headline">
            404 Nicht gefunden
        </div>

        <div class="description">
            Leider wissen wir mit der von Ihnen angefragten URL nichts anzufangen.
        </div>

        <div class="key-value-wrapper">
            <span>Url</span>
            <span>{{url}}</span>
        </div>

        <mat-icon class="icon danger-font">block</mat-icon>

    </div>
    <div class="spacer"></div>

</div>